import { isFunction } from '@sureapp/wl-toggle-common/dist/services';
import { assignWith } from 'lodash';

import type { TConfig, TConfigInput } from '@@/auto/interfaces';

export function customizer(old: any, override: any) {
  return Array.isArray(old) && Array.isArray(override) ? override : undefined;
}
export function overrideObjectsAndArrays(
  defaultConfig: TConfig,
  newConfig: DeepPartial<TConfig> | DeepPartial<TConfigInput>
): TConfig {
  return assignWith({}, defaultConfig, newConfig, customizer);
}

export function functionCustomizer(old: any, override: any) {
  const isOverrideFunction = isFunction(override);
  return isOverrideFunction ? override : undefined;
}
export function overrideFunctions(
  defaultConfig: TConfig,
  newConfig: DeepPartial<TConfig> | DeepPartial<TConfigInput>
): TConfig {
  return assignWith({}, defaultConfig, newConfig, customizer);
}
